export default __webpack_public_path__ + "static/media/Mark-5-Suit-04.7faab762.jpg";